var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"featured_post_listing"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"inner"},_vm._l((_vm.parsedPageLinks),function(tile,index){return _c('post-tile',{key:index,attrs:{"name":tile.title,"short_description":tile.description,"image":tile.image ? tile.image.url : null,"permalink":{
                url: tile.url,
                target: '_self',
                title: tile.title,
              },"tag":tile.tag ? tile.tag : null,"post_type":tile.post_type,"date":tile.date,"index":'index_' + index,"data-aos":"fade-up","data-aos-duration":"300","data-aos-offset":50,"data-aos-delay":index * 50}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/FeaturedPostListing.vue